import React from 'react';
import styled from 'styled-components';

interface IProps {
  icon: string;
  text: string;
  className?: string;
}

const NoData = ({ text, icon, className }: IProps): React.ReactElement => {
  return (
    <Container className={className}>
      <Icon icon={icon} />
      {text}
    </Container>
  );
};

export { NoData };

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 5.75rem;
  width: 100%;
  background-color: #f9fafb;
  border: 1px solid #f3f4f6;
  box-shadow: none;
  font-weight: 500;
  line-height: 20px;
  color: #4b5563;
  border-radius: 8px;
`;

const Icon = styled.div<{ icon: string }>`
  height: 24px;
  width: 24px;
  color: #4b5563;
  background-image: ${({ icon }) => `url(${icon})`};
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 0.25rem;
`;
